import { get, post } from '@/common/request/index';

const OPTIONS = { isMock: false, mockId: 0, mockSuffix: '/api', needHint: true };

/**
 * 查询公共资源库项目，包含待审核项目。
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100434
 *  */
export function resourceProjectPage(params: any) {
  return post('/standard/chancePoint/resourceProject/page', params, OPTIONS);
}

/** 查询公共项目在流量分发场地库租户下的点位。 */
export function resourceSpotPage(params: any) {
  return post('/standard/chancePoint/resourceSpot/page', params, OPTIONS);
}

/** 查询所选流量分发场地库点位的完整属性，用于回填机会点表单。 */
export function resourceSpotDetail(params: any) {
  return post('/standard/chancePoint/resourceSpot/detail', params, OPTIONS);
}

/** 查询资源中心二级类目；resourcesType=1 表示点位类目。 */
export function resourceCategoryList(params: any) {
  return get('/category/list', params, { isRes: true, needCancel: false, needHint: true });
}
